import _Object$setPrototypeOf from "core-js/library/fn/object/set-prototype-of.js";
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
export { _setPrototypeOf as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js
// module id = 401
// module chunks = 4